import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { DateInput, TextareaInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function HistoriqueFields({ item, set }) {
    const t = useTranslations()
    return <>
        <Row>
            <DateInput label={t("Date")} value={item.date} onChange={set('date')} required />
        </Row>
        <TextareaInput className="[&_textarea]:text-red-600" label={t("Mémo interne")} value={item.memoInterne} onChange={set('memoInterne')} required />
    </>
}

export function HistoriquesList(props) {
    const t = useTranslations()
    return <ListPage model="historique" title={t("Historique")} columns={{
        [t('Date')]: 'date',
        [t('Mémo interne')]: { sort: 'memoInterne', value: item => item.memoInterne?.length > 100 ? item.memoInterne.slice(0, 100) + '...' : item.memoInterne },
    }}{...props} />
}

export function HistoriqueDetail(props) {
    const t = useTranslations()
    return <DetailPage model="historique" title={t("Historique")} Fields={HistoriqueFields} {...props} />
}
